import React, { useCallback, useState } from 'react'
import { useEffect } from 'react'
import { Provider } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

import api from 'api'
import ErrorMessage from 'components/Common/ErrorMessage'
import LoadingMessage from 'components/Common/LoadingMessage'
import { makeSubscribable } from 'helpers'
import { store } from 'reduxStore'
import routes from 'routes'

const AppStateProvider = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [loading, setloading] = useState(true)

  const user = store.getState().userReducer.user
  const error = store.getState().error

  const onError = useCallback(
    err => {
      if (
        err === 'The user is not authenticated' ||
        err === 'No current user' ||
        err?.message === 'Access Token has been revoked'
      ) {
        setloading(false)
        if (
          location.pathname !== '/auth/EP/:EPSGId' &&
          location.pathname !== '/auth/verify-password' &&
          location.pathname !== '/auth/resend-mail' &&
          location.pathname !== '/auth/sign-up' &&
          location.pathname !== '/auth/verify-otp' &&
          location.pathname !== '/auth/create-password' &&
          location.pathname !== '/use-browser' &&
          location.pathname !== routes.auth.forgotPassword &&
          !location.pathname.includes(routes.ownerBeneficialForm) &&
          !location.pathname.includes('/articlesharing')
        ) {
          if (!location.pathname.includes('/auth')) {
            navigate('/auth')
          }
        }
      } else {
        store.dispatch({ type: 'setError', payload: err })
      }
    },
    [navigate, location],
  )

  const onErrorMessageCloseClick = useCallback(() => {
    store.dispatch({ type: 'clearError' })
  }, [])

  const onUserLoadSuccess = useCallback(user => {
    const messages = JSON.parse(localStorage.getItem('messages') || '[]')
    user.avatarUrl = user?.avatarFileId
      ? `${process.env['REACT_APP_BACKEND_BASE_URL']}/static/images/users/${user?.avatarFileId}`
      : ''
    store.dispatch({ type: 'userLoaded', user })
    store.dispatch({ type: 'messagesLoaded', payload: messages })
    setloading(false)
  }, [])

  const onUserCheckSuccess = useCallback(user => {
    store.dispatch({ type: 'userUpdated', user })
  }, [])

  const onMessages = useCallback(data => {
    store.dispatch({ type: 'messagesLoaded', payload: data })
  }, [])

  useEffect(() => {
    if (user === null) {
      makeSubscribable(api.getUser()).subscribe(onUserLoadSuccess, onError)
    }
  }, [onError, onUserLoadSuccess, user])

  useEffect(() => {
    const userCheckSubscribable = api.checkUserData()
    return userCheckSubscribable.subscribe(onUserCheckSuccess, onError)
  }, [onError, onUserCheckSuccess])

  useEffect(() => {
    return api.onMessages(onMessages, onError)
  }, [onError, onMessages])

  if (error) {
    // @ts-ignore
    if (error !== 'No current user') {
      // This is terrible and we should refactor this whole logic for error and loading
      return <ErrorMessage error={error} onCloseClick={onErrorMessageCloseClick} />
    }
  }

  if (loading) {
    return <LoadingMessage />
  }

  return <Provider store={store}>{children}</Provider>
}

export default AppStateProvider
